<template>
  <section class="content-block">
    <transition name="slide-fade">
      <div
        v-show="active"
        class="block has-white-background"
      >
        <div class="inner-block is-flex">
          <div class="col-2">
            <h1 class="title">
              *{{ $t("datenView.label.firstName") }}
            </h1>
            <input
              class="input"
              id="firstname"
              type="text"
              v-model="firstname"
            >
          </div>
          <div class="col-2">
            <h1 class="title">
              *{{ $t("datenView.label.lastName") }}
            </h1>
            <input
              class="input"
              id="lastname"
              type="text"
              v-model="lastname"
            >
          </div>
          <div class="col-2">
            <h1 class="title">
              *{{ $t("datenView.label.email") }}
            </h1>
            <input
              class="input"
              id="email"
              type="email"
              v-model="email"
              @input="checkEmailMatch"
            >
            <p
              v-if="this.is_mail_valid"
              class="input-note"
            >
              {{ $t("datenView.label.emailHint") }}
            </p>
            <p
              v-else
              class="input-note is-alert help is-danger"
            >
              {{ $t("datenView.label.enterValidEmail") }}
            </p>
          </div>
          <div class="col-2">
            <h1 class="title">
              *{{ $t("datenView.label.emailRepeat") }}
            </h1>
            <input
              class="input"
              id="email"
              type="email"
              v-model="emailRepeat"
              @input="checkEmailMatch"
            >
            <p
              v-if="!this.emailsMatch"
              class="input-note is-alert help is-danger"
            >
              {{ $t("datenView.label.emailsDontMatch") }}
            </p>
          </div>
          <div class="col-2">
            <h1 class="title">
              *{{ $t("datenView.label.telephone") }}
            </h1>
            <input
              class="input"
              id="telephone"
              type="tel"
              v-model="telephone"
            >
            <p class="input-note">
              {{ $t("datenView.label.telHint") }}
            </p>
          </div>
          <div class="col-1">
            <h1 class="title">
              {{ $t("datenView.label.messageComment") }}
            </h1>
            <textarea
              class="input"
              id="message"
              maxlength="128"
              type="text"
              v-model="comment"
            />
            <p class="input-note">
              {{
                this.$store.state.fahrttyp === 'ascent'
                  ? this.$t('datenView.label.commentHintAscentDescent')
                  : this.$t('datenView.label.commentHintSunriseSunset')
              }}
            </p>
          </div>
          <!--<div ref="captcha" id="reservation-captcha"></div>-->
        </div>
        <div class="inner-block note-block">
          <p class="subtitle">
            * {{ $t("datenView.label.mandatoryFields") }}
          </p>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'Daten',
  data() {
    return {
      active: false,
      is_mail_valid: true,
      emailsMatch: true,
      reservationCaptcha: null
    }
  },
  computed: {
    firstname: {
      get() {
        return this.$store.state.customer.firstName;
      },
      set(value) {
        this.$store.state.customer.firstName = value;
      }
    },
    lastname: {
      get() {
        return this.$store.state.customer.lastName;
      },
      set(value) {
        this.$store.state.customer.lastName = value;
      }
    },
    email: {
      get() {
        return this.$store.state.customer.email;
      },
      set(value) {
        this.validEmail(value);
        this.checkEmailMatch();
        this.$store.state.customer.email = value;
      }
    },
    emailRepeat: {
      get() {
        return this.$store.state.customer.emailRepeat;
      },
      set(value) {
        this.checkEmailMatch();
        this.$store.state.customer.emailRepeat = value;
      }
    },
    telephone: {
      get() {
        return this.$store.state.customer.telephone;
      },
      set(value) {
        this.$store.state.customer.telephone = value;
      }
    },
    comment: {
      get() {
        return this.$store.state.comment;
      },
      set(value) {
        this.$store.state.comment = value;
      }
    }
  },
  mounted() {
    /*
    const initCaptcha = async () => {
      await loadScript(liveURL + "/api/captcha/render/js");
      this.reservationCaptcha = window.IncCaptcha.render(document.getElementById('reservation-captcha'));
    }
    initCaptcha();
    */
    this.active = true;
  },
  methods: {
    checkEmailMatch: function () {
      this.emailsMatch = this.email === this.emailRepeat;
    },
    validEmail: function (email) {
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.is_mail_valid = re.test(email);
    }
  }
}
</script>

<style scoped lang="scss">
textarea {
  min-height: 100px;
}
</style>
